import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchProductById } from "./api";
import { Input, Spin } from "antd";
import Navbar from "../../components/Navbar";
import "./catalogDetailPage.css";
import { fetchProducts } from "../Home/api";
import { Back } from "iconsax-react";
import { LogoMarque } from "../../components/LogoMarque";
import OtherProductsSlider from "./OtherProductsSlider";
import ProductImageSlider from "./ProductImageSlider";
import PartnerLogos from "../Home/PartnerLogos";
import WhatsAppFloatButton from "../../components/DialMenu/WhatsappFloatButton";

const CatalogDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [otherProducts, setOtherProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchProductById(id), fetchProducts()])
      .then(([detailData, allData]) => {
        const currentProduct = {
          ...detailData?.data,
          stock: Math.floor(Math.random() * 50) + 1,
        };

        const other = allData?.data
          .filter((p) => p.id !== parseInt(id))
          .map((p) => ({
            ...p,
            stock: Math.floor(Math.random() * 50) + 1,
          }));

        setProduct(currentProduct);
        setOtherProducts(other);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const formatRupiah = (number) =>
    new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(number * 16000);

  return (
    <>
      <Navbar />
      <div className="catalog-detail-page min-h-screen text-[#5c4033] font-serif p-8 pt-20">
        {loading ? (
          <div className="flex justify-center items-center min-h-[50vh]">
            <Spin
              size="large"
              tip="Loading product detail..."
              className="custom-spin"
            />
          </div>
        ) : (
          <>
            {/* Logo Marquee */}
            <LogoMarque />
            {/* Our Partner Section */}
            <PartnerLogos />
            {/* Back Button */}
            <div className="max-w-4xl mx-auto mb-4 flex justify-end">
              <button
                onClick={() => navigate("/")}
                className="flex items-center gap-2 px-3 py-2 bg-[#5c4033] text-white rounded hover:bg-[#3a2c1e] transition text-sm"
              >
                <Back size="16" color="#fff" /> Back
              </button>
            </div>

            {/* Product Detail */}
            <div className="catalog-detail-container max-w-4xl mx-auto flex flex-col md:flex-row gap-8 mb-16">
              {/* Image Slider */}
              <ProductImageSlider images={product.images} />

              {/* Detail Text */}
              <div className="flex-1 space-y-4">
                <h1 className="text-2xl font-bold">{product.title}</h1>
                <Input.TextArea
                  value={product.description}
                  readOnly
                  autoSize
                  className="!text-sm !text-[#5c4033] !bg-transparent !border-none !p-0"
                />
                <div className="text-lg font-semibold text-[#5c4033]">
                  {/* {formatRupiah(product.price)} */}
                </div>
                <div className="text-sm text-gray-600">
                  {/* Stok: {product.stock} */}
                </div>
              </div>
            </div>

            {/* Produk Lainnya */}
            <OtherProductsSlider
              products={otherProducts}
              formatRupiah={formatRupiah}
              currentProductId={product.id}
            />
          </>
        )}
      </div>
      <WhatsAppFloatButton />
    </>
  );
};

export default CatalogDetailPage;
